module.exports = __webpack_public_path__ + "static/media/contao.78a02f89.svg";